import React from 'react';
import PropTypes from 'prop-types';
import { useEntitiesFulfillmentPlan } from '../../../../../hooks/entities/selectors/fulfillment-plans';
import { useActiveFulfillmentForFulfillmentPlan } from '../../../../../hooks/entities/selectors/fulfillments';
import { MissingLabelProvider } from './missing-label-provider';
import { RateCardContent } from './rate-card-content';

export const RateCard = ({ fulfillmentPlanId }) => {
  const fulfillmentPlan = useEntitiesFulfillmentPlan(fulfillmentPlanId);
  const { sellerLabelProviderId } = fulfillmentPlan || {};
  const fulfillment = useActiveFulfillmentForFulfillmentPlan(fulfillmentPlanId);
  if (!sellerLabelProviderId) {
    return <MissingLabelProvider />;
  }

  return <RateCardContent fulfillment={fulfillment} fulfillmentPlan={fulfillmentPlan} />;
};

RateCard.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
